import { VoucherModel } from "../schema";

export class VoucherContainer {
    voucher: VoucherModel
}